import Swal from 'sweetalert2'

let notify = (message, icon = 'info') => {
    if(icon === 'danger')
        icon = 'error';
    Swal.fire({
        icon,
        title: message,
        showConfirmButton: true,
        // timer: 1500
    })
    return true;
};

let confirmFirst = async (message, {
    title = 'Confirmación',
    confirmButtonText = 'Confirmar',
    cancelButtonText = 'Cancelar'
} = {}) => { 
    let SwalResponse =  await Swal.fire({
        title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText
    })
    console.log('Swal.fire.response', SwalResponse)
    return SwalResponse.isConfirmed;
}

export {
    confirmFirst, 
    notify
}